import { createApiService } from "@/core/api/apiService";
import type {
  CalendarEventConflictPreviewDto,
  CalendarEventConflictRequestDto,
  CalendarEventDto,
  CreateCalendarEventDto,
  UpdateCalendarEventDto,
} from "../types/calendarEventTypes";

function createCalendarEventApiService() {
  const api = createApiService("businesses");
  const collection = (businessId: string) => `${encodeURIComponent(businessId)}/calendar-events`;

  return {
    getAll: async (businessId: string, startAt: string, endAt: string, signal?: AbortSignal): Promise<CalendarEventDto[]> => {
      const query = new URLSearchParams({ startAt, endAt });
      return api.get<CalendarEventDto[]>(`${collection(businessId)}?${query}`, { signal });
    },
    getById: async (businessId: string, eventId: string, signal?: AbortSignal): Promise<CalendarEventDto> =>
      api.get<CalendarEventDto>(`${collection(businessId)}/${encodeURIComponent(eventId)}`, { signal }),
    create: async (businessId: string, data: CreateCalendarEventDto): Promise<CalendarEventDto> =>
      api.post<CalendarEventDto>(collection(businessId), data),
    update: async (businessId: string, eventId: string, data: UpdateCalendarEventDto): Promise<CalendarEventDto> =>
      api.put<CalendarEventDto>(`${collection(businessId)}/${encodeURIComponent(eventId)}`, data),
    delete: async (businessId: string, eventId: string, expectedVersion: number): Promise<{ message: string }> =>
      api.delete<{ message: string }>(`${collection(businessId)}/${encodeURIComponent(eventId)}?${new URLSearchParams({ expectedVersion: String(expectedVersion) })}`),
    getConflicts: async (businessId: string, data: CalendarEventConflictRequestDto): Promise<CalendarEventConflictPreviewDto> =>
      api.post<CalendarEventConflictPreviewDto>(`${collection(businessId)}/conflicts`, data),
  };
}

export const calendarEventApiService = createCalendarEventApiService();
